// extracted by mini-css-extract-plugin
export default {"body":"Counter_body__xuoaA","display":"Counter_display__KI5nW"};